import {
  ABILITY_TOUKETSU_BOUSHI_INPUT,
  ABILITY_YUSETSU_INPUT,
  ABILITY_KISEI_INPUT,
  ABILITY_JOSETSU_INPUT,
  ABILITY_HAISETSU_INPUT,
  ABILITY_SETTOU_PATROL_REPORT_INPUT,
  ABILITY_ENSUI_PLANT_STOCK_INPUT,
  ABILITY_SETTOU_ONSITE_MANAGEMENT_REPORT_INPUT,
} from '@/consts/ability';
import {
  JOHAISETSU_TYPE_GROUP_TOUKETSU_BOUSHI_SAGYOU,
  JOHAISETSU_TYPE_GROUP_YUSETSU_SAGYOU,
  JOHAISETSU_TYPE_GROUP_KISEI_SAGYOU,
  JOHAISETSU_TYPE_GROUP_JOSETSU_SAGYOU,
  JOHAISETSU_TYPE_GROUP_HAISETSU_SAGYOU,
  JOHAISETSU_TYPE_GROUP_SETTOU_PATROL,
  JOHAISETSU_TYPE_GROUP_SETTOU_ONSITE_MANAGEMENT,
} from '@/consts/johaisetsu_car';
import { JohaisetsuSagyou } from '@/components/Sp/Johaisetsu/types';
import johaisetsuReportApi from '@/apis/johaisetsu/settouSagyouReport/johaisetsu_report';
import johaisetsuSettouPatrolApi from '@/apis/johaisetsu/settouPatrol/settouPatrol/johaisetsu_settou_patrol';
import johaisetsuSettouOnsiteManagementApi from '@/apis/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsu_settou_onsite_management';

export const JOHAISETSU_SAGYOU_MENU: JohaisetsuSagyou[] = [
  {
    key: 'touketsu_boushi',
    label: '凍結防止作業',
    ability: ABILITY_TOUKETSU_BOUSHI_INPUT,
    component: 'SettouSagyouCommon',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_TOUKETSU_BOUSHI_SAGYOU,
    getCurrentReport: johaisetsuReportApi.getCurrent,
  },
  {
    key: 'yusetsu',
    label: '融雪作業',
    ability: ABILITY_YUSETSU_INPUT,
    component: 'SettouSagyouCommon',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_YUSETSU_SAGYOU,
    getCurrentReport: johaisetsuReportApi.getCurrent,
  },
  {
    key: 'kisei',
    label: '規制作業',
    ability: ABILITY_KISEI_INPUT,
    component: 'SettouSagyouCommon',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_KISEI_SAGYOU,
    getCurrentReport: johaisetsuReportApi.getCurrent,
  },
  {
    key: 'josetsu',
    label: '除雪作業',
    ability: ABILITY_JOSETSU_INPUT,
    component: 'SettouSagyouCommon',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_JOSETSU_SAGYOU,
    getCurrentReport: johaisetsuReportApi.getCurrent,
  },
  {
    key: 'haisetsu',
    label: '排雪作業',
    ability: ABILITY_HAISETSU_INPUT,
    component: 'SettouSagyouCommon',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_HAISETSU_SAGYOU,
    getCurrentReport: johaisetsuReportApi.getCurrent,
  },
  {
    key: 'settou_patrol',
    label: '雪凍パトロール報告',
    ability: ABILITY_SETTOU_PATROL_REPORT_INPUT,
    component: 'SettouPatrol',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_SETTOU_PATROL,
    sagyouActionLabel: 'パトロール',
    getCurrentReport: johaisetsuSettouPatrolApi.getCurrent,
  },
  {
    key: 'onsite_management',
    label: '進捗管理専任者・現場指揮者現場報告',
    ability: ABILITY_SETTOU_ONSITE_MANAGEMENT_REPORT_INPUT,
    component: 'SettouOnsiteManagement',
    johaisetsuTypeGroup: JOHAISETSU_TYPE_GROUP_SETTOU_ONSITE_MANAGEMENT,
    sagyouActionLabel: '作業',
    getCurrentReport: johaisetsuSettouOnsiteManagementApi.getCurrent,
  },
  {
    key: 'ensui_plant_stock',
    label: '塩水プラント在庫報告',
    ability: ABILITY_ENSUI_PLANT_STOCK_INPUT,
    component: 'EnsuiPlantStockReport',
  },
];

export const JOHAISETSU_SAGYOU_MENU_MAP: Map<string, JohaisetsuSagyou> =
  new Map(JOHAISETSU_SAGYOU_MENU.map(m => [m.key, m]));
